import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon, PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-secondary border-t border-surface pt-16 pb-8" data-id="element-22">
      <div className="container mx-auto px-4" data-id="element-23">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-24">
          {/* Company Info */}
          <div data-id="element-25">
            <div className="mb-6 bg-surface inline-block p-4 rounded-lg" data-id="element-26">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ibuVzkycDnA7HHUx1J6KA1/magnavera-logo.jpg" alt="Magnavera Group" className="h-12" data-id="element-27" />
            </div>
            <p className="text-text-secondary mb-6 leading-relaxed font-body" data-id="element-28">
              Empowering individuals and families with trusted guidance,
              lifelong education, and innovative wealth solutions.
            </p>
            <div className="flex space-x-4" data-id="element-29">
              <a href="#" aria-label="Facebook" className="bg-surface p-2.5 rounded-full hover:bg-primary hover:text-secondary transition-all duration-300" data-id="element-30">
                <FacebookIcon size={18} data-id="element-31" />
              </a>
              <a href="#" aria-label="Twitter" className="bg-surface p-2.5 rounded-full hover:bg-primary hover:text-secondary transition-all duration-300" data-id="element-32">
                <TwitterIcon size={18} data-id="element-33" />
              </a>
              <a href="#" aria-label="LinkedIn" className="bg-surface p-2.5 rounded-full hover:bg-primary hover:text-secondary transition-all duration-300" data-id="element-34">
                <LinkedinIcon size={18} data-id="element-35" />
              </a>
              <a href="#" aria-label="Instagram" className="bg-surface p-2.5 rounded-full hover:bg-primary hover:text-secondary transition-all duration-300" data-id="element-36">
                <InstagramIcon size={18} data-id="element-37" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-38">
            <h4 className="font-display font-bold text-lg mb-6 relative text-primary tracking-wider" data-id="element-39">
              QUICK LINKS
              <span className="absolute left-0 -bottom-2 w-12 h-1 bg-primary" data-id="element-40"></span>
            </h4>
            <ul className="space-y-3 font-body" data-id="element-41">
              {['Home', 'About Us', 'Services', 'Careers', 'FAQ', 'Contact Us'].map((item, index) => <li key={index} data-id="element-42">
                  <Link to={item === 'About Us' ? '/about' : item === 'Contact Us' ? '/contact' : `/${item.toLowerCase().replace(' ', '-')}`} className="text-text-secondary hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-43">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-44">
            <h4 className="font-display font-bold text-lg mb-6 relative text-primary tracking-wider" data-id="element-45">
              OUR SERVICES
              <span className="absolute left-0 -bottom-2 w-12 h-1 bg-primary" data-id="element-46"></span>
            </h4>
            <ul className="space-y-3 font-body" data-id="element-47">
              {['Wealth & Investment Solutions', 'Insurance & Protection', 'Estate & Legacy Planning', 'Corporate Solutions'].map((item, index) => <li key={index} data-id="element-48">
                  <Link to="/services" className="text-text-secondary hover:text-primary transition-colors duration-200 inline-block py-1" data-id="element-49">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-50">
            <h4 className="font-display font-bold text-lg mb-6 relative text-primary tracking-wider" data-id="element-51">
              CONTACT US
              <span className="absolute left-0 -bottom-2 w-12 h-1 bg-primary" data-id="element-52"></span>
            </h4>
            <ul className="space-y-4 font-body" data-id="element-53">
              <li className="flex items-start" data-id="element-54">
                <MapPinIcon className="text-primary mr-3 mt-1 flex-shrink-0" size={18} data-id="element-55" />
                <span className="text-text-secondary" data-id="element-56">
                  3 Pickering St, #02-08
                  <br data-id="element-57" />
                  Singapore 048660, Singapore
                </span>
              </li>
              <li className="flex items-center" data-id="element-58">
                <PhoneIcon className="text-primary mr-3 flex-shrink-0" size={18} data-id="element-59" />
                <a href="tel:+6589701506" className="text-text-secondary hover:text-primary transition-colors duration-200" data-id="element-60">
                  +65 8970 1506
                </a>
              </li>
              <li className="flex items-center" data-id="element-61">
                <MailIcon className="text-primary mr-3 flex-shrink-0" size={18} data-id="element-62" />
                <a href="mailto:vjayvarmmanadmin@rep.greateasternfa.sg" className="text-text-secondary hover:text-primary transition-colors duration-200 text-sm" data-id="element-63">
                  vjayvarmmanadmin@rep.greateasternfa.sg
                </a>
              </li>
              <li className="flex items-start" data-id="element-64">
                <ClockIcon className="text-primary mr-3 mt-1 flex-shrink-0" size={18} data-id="element-65" />
                <span className="text-text-secondary" data-id="element-66">
                  Mon-Fri: By appointment only
                  <br data-id="element-67" />
                  Closed on Sat and Sun
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="pt-8 border-t border-surface mb-8" data-id="element-68">
          <p className="text-xs text-text-secondary/60 leading-relaxed font-body" data-id="element-69">
            The views and opinions expressed in this website are solely that of
            the author and do not necessarily reflect the opinion of Great
            Eastern Financial Advisers Private Limited (GEFA). For the avoidance
            of doubt, GEFA does not make any representations or warranties,
            express or implied, as to the completeness or accuracy of the
            information contained in this website. Further, GEFA expressly
            disclaims any and all liability relating to or arising from the use
            of and/or reliance on the information contained in this website. The
            information contained in this website is for your information only
            and does not have regard to the specific investment objectives,
            financial situation and particular needs of any person(s).
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-surface" data-id="element-70">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-71">
            <p className="text-sm text-text-secondary mb-4 md:mb-0 font-body" data-id="element-72">
              © {currentYear} Magnavera Group. All rights reserved.
            </p>
            <p className="text-xs text-text-secondary/60 font-body" data-id="element-73">
              Magnavera Group is a group of representatives of Great Eastern
              Financial Advisers Pte Ltd (GEFA).
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;